var map = {
	"./AW1.svg": 7659,
	"./AW2.svg": 6296,
	"./AW3.svg": 4217,
	"./AW4.svg": 8982,
	"./Arrow1.svg": 5510,
	"./Arrow2.svg": 6757,
	"./Aw5.svg": 2695,
	"./Eis2_hb_w.jpg": 1622,
	"./Outbound2_w_b.jpg": 1425,
	"./f_logo_RGB-Blue_58.png": 6743,
	"./fonts/MontserratSubrayada-Bold.ttf": 8630,
	"./fonts/MontserratSubrayada-Regular.ttf": 2272,
	"./fonts/Rajdhani-Light.ttf": 7138,
	"./fonts/Rajdhani-Regular.ttf": 6618,
	"./fonts/Yantramanav-Bold.ttf": 890,
	"./fonts/Yantramanav-Light.ttf": 6153,
	"./fonts/Yantramanav-Medium.ttf": 6490,
	"./fonts/Yantramanav-Regular.ttf": 9193,
	"./fonts/Yantramanav-Thin.ttf": 3446,
	"./galleryPictures/0_Offen_w_kl.jpg": 1867,
	"./galleryPictures/Abstraktus1_w.jpg": 985,
	"./galleryPictures/Abstraktus2_bw.jpg": 5008,
	"./galleryPictures/Abstraktus3_b_k_w.jpg": 3182,
	"./galleryPictures/Anglerwurm_w.jpg": 2390,
	"./galleryPictures/BaumImFeld_k_w.jpg": 7454,
	"./galleryPictures/Befreiung_w.jpg": 7413,
	"./galleryPictures/Bienendrache_bw.jpg": 9410,
	"./galleryPictures/Bischl_k_w.jpg": 5431,
	"./galleryPictures/BlackGhost_w.jpg": 2966,
	"./galleryPictures/Blaukappen_Oktling_k_w.jpg": 6532,
	"./galleryPictures/Break_Free_w.jpg": 6790,
	"./galleryPictures/BrokenWall_w.jpg": 7951,
	"./galleryPictures/Buntfisch_w.jpg": 402,
	"./galleryPictures/Buntkiemer1_w.jpg": 2805,
	"./galleryPictures/Buntkiemer2_w.jpg": 8006,
	"./galleryPictures/Caged2_w.jpg": 8122,
	"./galleryPictures/Circles10_b_k_w.jpg": 287,
	"./galleryPictures/Circles11_b_k_w.jpg": 1482,
	"./galleryPictures/Circles12_b_k_w.jpg": 465,
	"./galleryPictures/Circles14_b_k_w.jpg": 8323,
	"./galleryPictures/Circles15_b_k_w.jpg": 7310,
	"./galleryPictures/Circles16_b_k_w.jpg": 8725,
	"./galleryPictures/Circles17_b_k_w.jpg": 4528,
	"./galleryPictures/Circles18_b_k_w.jpg": 7735,
	"./galleryPictures/Circles19_b_k_w.jpg": 8322,
	"./galleryPictures/Circles1_b_k_w.jpg": 6337,
	"./galleryPictures/Circles20_b_k_w.jpg": 190,
	"./galleryPictures/Circles21_b_k_w.jpg": 1891,
	"./galleryPictures/Circles23_b_k_w.jpg": 4645,
	"./galleryPictures/Circles24_b_k_w.jpg": 7450,
	"./galleryPictures/Circles2_b_k_w.jpg": 8602,
	"./galleryPictures/Circles4_b_k_w.jpg": 4432,
	"./galleryPictures/Circles5_b_k_w.jpg": 53,
	"./galleryPictures/Circles8_b_k_w.jpg": 3380,
	"./galleryPictures/Colomander_w.jpg": 3120,
	"./galleryPictures/ComingToAnEnd2_b_w.jpg": 4579,
	"./galleryPictures/Connection_w.jpg": 7016,
	"./galleryPictures/Delfin_gif_reduced.gif": 4783,
	"./galleryPictures/Den Fremden willkommen geheißen_w.jpg": 2559,
	"./galleryPictures/Depressed_w.jpg": 6339,
	"./galleryPictures/Depressive_b_w.jpg": 2791,
	"./galleryPictures/Despair_b_w.jpg": 8473,
	"./galleryPictures/Draffi_k_w.jpg": 3962,
	"./galleryPictures/DyingInFrontOfARedMoon_b_d_w.jpg": 2867,
	"./galleryPictures/EineVonMillionen_w.jpg": 11,
	"./galleryPictures/Eis2_hb_w.jpg": 8472,
	"./galleryPictures/Eisbaer_Detail_2_b_w.jpg": 1881,
	"./galleryPictures/Eisbaer_Detail_b_w.jpg": 4354,
	"./galleryPictures/Eisbaer_Frontal_2_b_w.png": 2350,
	"./galleryPictures/Eisbaer_Frontal_w.jpg": 7102,
	"./galleryPictures/Eisbaer_Oben_w.jpg": 8488,
	"./galleryPictures/Eisbaer_Quer_w.jpg": 3281,
	"./galleryPictures/Farbenfisch_w.jpg": 3087,
	"./galleryPictures/FeelingLeftAlone_w.jpg": 5552,
	"./galleryPictures/Feuer1_w.jpg": 8278,
	"./galleryPictures/Feuer2_w.jpg": 5509,
	"./galleryPictures/Frost1_k_w.jpg": 449,
	"./galleryPictures/Frost2_k_w.jpg": 5726,
	"./galleryPictures/Gefangen2_w.jpg": 6041,
	"./galleryPictures/Gefangen_w.jpg": 6427,
	"./galleryPictures/Gejagt_w.jpg": 6434,
	"./galleryPictures/Gestreifter_Augling_k_w.jpg": 312,
	"./galleryPictures/Ghostly1_k_w.jpg": 6347,
	"./galleryPictures/Ghostly2_k_w.jpg": 1604,
	"./galleryPictures/Giraffenpuppe_kl_w.jpg": 5506,
	"./galleryPictures/Gnubbelmonster_w.jpg": 6139,
	"./galleryPictures/GrassesAndMoon2_k_w.jpg": 6224,
	"./galleryPictures/GrassesAndMoon_k_w.jpg": 8360,
	"./galleryPictures/GrassesAndSun2_k_w.jpg": 2216,
	"./galleryPictures/GrassesAndSun_k_w.jpg": 7957,
	"./galleryPictures/Gurr_w.jpg": 5536,
	"./galleryPictures/GuyWithAUniverseInHisStomach_w.jpg": 5662,
	"./galleryPictures/Hahn_w.jpg": 2439,
	"./galleryPictures/High-Flying_w.jpg": 822,
	"./galleryPictures/Hippocolorus_w.jpg": 9745,
	"./galleryPictures/Hmbaba2_k_w.jpg": 3901,
	"./galleryPictures/Hmbaba_k_w.jpg": 4311,
	"./galleryPictures/Hoocolopoe_w.jpg": 2909,
	"./galleryPictures/Horngeier_w.jpg": 5907,
	"./galleryPictures/Hornkröte_bw.jpg": 2257,
	"./galleryPictures/HuhnGif_TransparenzOptimized.gif": 1856,
	"./galleryPictures/Huschl_k_w.jpg": 3381,
	"./galleryPictures/Im Jahre 54000_b_w.jpg": 8734,
	"./galleryPictures/Im Jahre 54001_b_w.jpg": 7291,
	"./galleryPictures/ImNotAGirl2_w.jpg": 8560,
	"./galleryPictures/InkTree1_k_w.jpg": 1439,
	"./galleryPictures/InkTree2_k_w.jpg": 4104,
	"./galleryPictures/Jellish_kl_w.jpg": 8757,
	"./galleryPictures/Kaninchen_gif_reduced.gif": 6944,
	"./galleryPictures/Konfumu_w.jpg": 9395,
	"./galleryPictures/LebenAufTod2_bw.jpg": 7749,
	"./galleryPictures/LittleMonster_bw.jpg": 9130,
	"./galleryPictures/MagicMushrooms_b_w.jpg": 3122,
	"./galleryPictures/Meise_nv_w.jpg": 9986,
	"./galleryPictures/Moritzburg_w.jpg": 7031,
	"./galleryPictures/Muuh3_Wiese_nv_w.jpg": 3623,
	"./galleryPictures/Muuh3_w.jpg": 7950,
	"./galleryPictures/Nöfnöf2_w.jpg": 9968,
	"./galleryPictures/Okdelisch_w.jpg": 3858,
	"./galleryPictures/Oktopus mit Müll_b_w.jpg": 4371,
	"./galleryPictures/Outbound1_w_b.jpg": 80,
	"./galleryPictures/Outbound2_w_b_h.jpg": 390,
	"./galleryPictures/Outbound4_b_w.jpg": 8993,
	"./galleryPictures/P1060322.jpg": 6886,
	"./galleryPictures/P1060333.jpg": 8980,
	"./galleryPictures/P1060343.jpg": 9389,
	"./galleryPictures/P1060349.jpg": 5671,
	"./galleryPictures/P1060350.jpg": 1126,
	"./galleryPictures/P1060352.jpg": 9067,
	"./galleryPictures/P1060354.jpg": 7141,
	"./galleryPictures/P1060355.jpg": 6232,
	"./galleryPictures/P1060356.jpg": 8807,
	"./galleryPictures/P1060359.jpg": 7156,
	"./galleryPictures/P1060368.jpg": 4944,
	"./galleryPictures/P1060371.jpg": 4154,
	"./galleryPictures/P1060375.jpg": 7934,
	"./galleryPictures/P1060376.jpg": 5049,
	"./galleryPictures/P1060377.jpg": 3996,
	"./galleryPictures/P1060378.jpg": 8719,
	"./galleryPictures/P1060380.jpg": 8998,
	"./galleryPictures/P1060382.jpg": 532,
	"./galleryPictures/P1060386.jpg": 1232,
	"./galleryPictures/P1060388.jpg": 5566,
	"./galleryPictures/P1060392.jpg": 7759,
	"./galleryPictures/P1060393.jpg": 5090,
	"./galleryPictures/P1060394.jpg": 4321,
	"./galleryPictures/P1060395.jpg": 596,
	"./galleryPictures/P1060396.jpg": 5075,
	"./galleryPictures/P1060398.jpg": 6405,
	"./galleryPictures/P1060400.jpg": 7005,
	"./galleryPictures/Pandopus_b2w.jpg": 4634,
	"./galleryPictures/PapageiFisch_w.jpg": 2520,
	"./galleryPictures/Piep2_w.jpg": 8522,
	"./galleryPictures/Reaching_Out_For_Help_w.jpg": 2406,
	"./galleryPictures/Roter_Mauling_k_w.jpg": 7580,
	"./galleryPictures/Rückkehr_w.jpg": 4170,
	"./galleryPictures/Schildkröte_w.jpg": 933,
	"./galleryPictures/Schildkrötenhölle_w.jpg": 8092,
	"./galleryPictures/Schleimiger_Wutling_k_w.jpg": 1565,
	"./galleryPictures/Schwarm_w.jpg": 6179,
	"./galleryPictures/SchwarzGrau10_b_k_w.jpg": 7455,
	"./galleryPictures/SchwarzGrau1_b_k_w.jpg": 2177,
	"./galleryPictures/SchwarzGrau2_b_k_w.jpg": 3082,
	"./galleryPictures/SchwarzGrau4_b_k_w.jpg": 5872,
	"./galleryPictures/SchwarzGrau5_b_k_w.jpg": 4229,
	"./galleryPictures/SchwarzGrau6_b_k_w.jpg": 1326,
	"./galleryPictures/SchwarzGrau7_b_k_w.jpg": 7651,
	"./galleryPictures/SchwarzGrau8_b_k_w.jpg": 276,
	"./galleryPictures/SchwarzGrau9_b_k_w.jpg": 8457,
	"./galleryPictures/ShiningThing_w.jpg": 1760,
	"./galleryPictures/Staring1_gif_reduced.gif": 9360,
	"./galleryPictures/Staring2_gif_reduced.gif": 7623,
	"./galleryPictures/Stormy_w.jpg": 4324,
	"./galleryPictures/Tangled1_w_b.jpg": 7507,
	"./galleryPictures/Tangled2_w.jpg": 9559,
	"./galleryPictures/Tangled3_final_b_w.jpg": 4068,
	"./galleryPictures/Tangled5_b_w.jpg": 4903,
	"./galleryPictures/ThatFeeling_b_w.jpg": 7144,
	"./galleryPictures/TigerGifTransparenzOptimized.gif": 8351,
	"./galleryPictures/Tintenfisch_kl_w.jpg": 4461,
	"./galleryPictures/Trees_10_200_z_scaled_w.jpg": 6864,
	"./galleryPictures/Trees_1_200_z_scaled_w.jpg": 176,
	"./galleryPictures/Trees_2_200_z_scaled_w.jpg": 7301,
	"./galleryPictures/Trees_3_200_z_scaled_w.jpg": 5366,
	"./galleryPictures/Trees_4_200_z_scaled_w.jpg": 9819,
	"./galleryPictures/Trees_5_200_z_scaled_w.jpg": 9708,
	"./galleryPictures/Trees_6_200_z_scaled_w.jpg": 9841,
	"./galleryPictures/Trees_7_200_z_scaled_w.jpg": 8290,
	"./galleryPictures/Trees_8_200_z_scaled_w.jpg": 1943,
	"./galleryPictures/Trees_9_200_z_scaled_w.jpg": 2424,
	"./galleryPictures/Tödlicher_Kappenpilz_k_w.jpg": 4806,
	"./galleryPictures/UnterWasser_w.jpg": 2311,
	"./galleryPictures/Violetter_Augling_k_w.jpg": 1125,
	"./galleryPictures/WaldleuchtenCollage_w.jpg": 7797,
	"./galleryPictures/Wellensittich-Befreiung_w.mp4": 8905,
	"./galleryPictures/Wellensittich_gif_reduced.gif": 5180,
	"./galleryPictures/Welli_hinter_Gittern_1_w.jpg": 2778,
	"./galleryPictures/Wellus Orangus_w.jpg": 5697,
	"./galleryPictures/WhatRemains_w.jpg": 1195,
	"./galleryPictures/WhiteWall.jpg": 3359,
	"./galleryPictures/Winterlandschaft_w.jpg": 1517,
	"./galleryPictures/Wolkenmaus_final2_w_s.jpg": 9915,
	"./galleryPictures/Wolkennashorn_w.jpg": 251,
	"./galleryPictures/Wolkenvogel_final_w_s.jpg": 4118,
	"./galleryPictures/Wüstenfrosch_w.jpg": 790,
	"./galleryPictures/Wüstenwürfel_w.jpg": 9171,
	"./galleryPictures/Zerrissen2_w.jpg": 9303,
	"./galleryPictures/Zerrissen_w.jpg": 3561,
	"./galleryPictures/abyss_w.jpg": 7154,
	"./galleryPictures/ezGif350-8-150.gif": 4740,
	"./galleryPictures/friedvollerFuchs_k_w.jpg": 3277,
	"./galleryPictures/jellyCats_b_k_w.jpg": 5932,
	"./galleryPictures/photos/DSC00016_sw_kl_w.jpg": 782,
	"./galleryPictures/photos/DSC00098_sw2_kl_w.jpg": 5896,
	"./galleryPictures/photos/DSC00190_sw_kl_w.jpg": 185,
	"./galleryPictures/photos/DSC00251_sw_kl_w.jpg": 231,
	"./galleryPictures/photos/DSC00391_sw_kl_w.jpg": 7906,
	"./galleryPictures/photos/DSC00474_sw_kl_w.jpg": 226,
	"./galleryPictures/photos/DSC00519_sw_kl_w.jpg": 9192,
	"./galleryPictures/photos/DSC00538_z_sw_kl_w.jpg": 5376,
	"./galleryPictures/photos/DSC00648_sw_kl_w.jpg": 7109,
	"./galleryPictures/photos/DSC00702_sw_kl_w.jpg": 7974,
	"./galleryPictures/photos/DSC00793_sw_kl_w.jpg": 8628,
	"./galleryPictures/photos/DSC00836_z_sw_kl_w.jpg": 1475,
	"./galleryPictures/photos/DSC00912_sw_kl_w.jpg": 6763,
	"./galleryPictures/photos/DSC01029_sw_z_kl_w.jpg": 5650,
	"./galleryPictures/photos/DSC01037_z_sw_kl_w.jpg": 7713,
	"./galleryPictures/photos/DSC01101_sw_kl_w.jpg": 5000,
	"./galleryPictures/photos/DSC01155_sw_kl_w.jpg": 6083,
	"./galleryPictures/photos/DSC01163_sw_kl_w.jpg": 4884,
	"./galleryPictures/photos/DSC01341_sw_kl_w.jpg": 854,
	"./galleryPictures/photos/DSC01674_z_sw_kl_w.jpg": 8912,
	"./galleryPictures/photos/DSC01717_z_sw_kl_w.jpg": 1960,
	"./galleryPictures/photos/DSC01864_sw_kl_w.jpg": 6822,
	"./galleryPictures/photos/DSC01878_z_sw_kl_w.jpg": 1826,
	"./galleryPictures/photos/DSC02266_sw_kl_w.jpg": 5151,
	"./galleryPictures/photos/DSC02335_sw_weich_kl_w.jpg": 7409,
	"./galleryPictures/photos/DSC02475_sw_z_kl_z_w.jpg": 6095,
	"./galleryPictures/photos/DSC02504_sw2_kl_w.jpg": 7560,
	"./galleryPictures/photos/DSC02543_sw_kl_w.jpg": 8047,
	"./galleryPictures/photos/DSC02551_sw_z2_kl_w.jpg": 4265,
	"./galleryPictures/photos/DSC02677_sw_z_kl_w.jpg": 7044,
	"./galleryPictures/photos/DSC02700_z_sw_kl_w.jpg": 9473,
	"./galleryPictures/photos/DSC02928_z2_sw_kl_w.jpg": 3385,
	"./galleryPictures/photos/DSC05036_z_sw_kl_w.jpg": 4000,
	"./galleryPictures/photos/DSC05232_sw_kl_w.jpg": 5021,
	"./galleryPictures/photos/DSC05638_z_sw_kl_w.jpg": 4244,
	"./galleryPictures/photos/DSC05682_sw_kl_w.jpg": 8800,
	"./galleryPictures/photos/DSC05820_sw_z_kl_w.jpg": 5119,
	"./galleryPictures/photos/DSC05876_z_sw_kl_w.jpg": 6436,
	"./galleryPictures/photos/DSC05926_z_sw2_kl_w.jpg": 958,
	"./galleryPictures/photos/DSC05964_sw_z_kl_w.jpg": 6378,
	"./galleryPictures/photos/DSC06365_z_sw_kl_z_w.jpg": 3509,
	"./galleryPictures/photos/DSC06465_z_sw_kl_z_w.jpg": 2738,
	"./galleryPictures/photos/DSC06538_sw_kl_w.jpg": 29,
	"./galleryPictures/photos/DSC06640_z_sw_z_kl_w.jpg": 161,
	"./galleryPictures/photos/DSC06762_z_sw_kl_z_w.jpg": 5042,
	"./galleryPictures/photos/DSC07088_z_sw_kl_w.jpg": 9517,
	"./galleryPictures/photos/DSC07195_sw_w_kl_w.jpg": 3515,
	"./galleryPictures/photos/DSC07710_sw_kl_w.jpg": 3842,
	"./galleryPictures/photos/DSC08940_z_sw_kl_z_w.jpg": 5862,
	"./galleryPictures/photos/DSC09264_z_sw_kl_w.jpg": 1471,
	"./galleryPictures/photos/PXL_20260305_153124150_sw_z2_kl_z_w.jpg": 40,
	"./galleryPictures/photos/PXL_20260307_115937332_sw_z_kl_w.jpg": 7978,
	"./galleryPictures/photos/PXL_20260307_120058497_sw_kl_w.MP.jpg": 4842,
	"./galleryPictures/photos/PXL_20260307_121033057_sw_z_kl_w.MP.jpg": 6215,
	"./galleryPictures/photos/PXL_20260307_122651858_sw_z_kl_w.jpg": 6982,
	"./galleryPictures/photos/PXL_20260307_124202050_sw_kl_w.jpg": 1505,
	"./galleryPictures/photos/PXL_20260307_124314081_sw_z_kl_w.jpg": 7282,
	"./galleryPictures/photos/PXL_20260307_131054851_sw_kl_w.jpg": 7179,
	"./galleryPictures/photos/PXL_20260311_211340923_sw_z3_kl_w.jpg": 4751,
	"./galleryPictures/photos/PXL_20260311_212420523~2_sw_kl_w.jpg": 8129,
	"./galleryPictures/photos/PXL_20260321_103146155_z_sw_kl_w.jpg": 9445,
	"./logo.png": 3153,
	"./placeholder/PlaceholderGalery.jpg": 141,
	"./placeholder/PlaceholderUebersicht.jpg": 6799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;